import styled, { css } from 'styled-components'
import { Box } from '../../../UI/Box'

const Bar = styled.div<{
  isFilled?: boolean
}>`
  width: 100%;
  height: 10px;
  ${(props) =>
    props.isFilled
      ? css`
          background: ${({ theme }) => theme.colors.brandPrimary};
        `
      : css`
          background: #3a5250;
        `}
`

const ProgressBox = styled(Box)`
  & > :first-child {
    border-radius: 5px 0 0 5px;
  }

  & > :last-child {
    border-radius: 0 5px 5px 0;
  }
`

export const ProgressBar = ({
  length,
  filled,
}: {
  length: number
  filled: number
}) => {
  return (
    <ProgressBox g={10} marginTop={6}>
      {Array(length)
        .fill(0)
        .map((_, index) => (
          <Bar key={index} isFilled={index < filled} />
        ))}
    </ProgressBox>
  )
}
